import axios from 'axios'

const API_URL = process.env.REACT_APP_ENV === 'prod' ? process.env.REACT_APP_API_PROD_URL : process.env.REACT_APP_API_DEV_URL

const PLANNING_API_URL = process.env.REACT_APP_API_PLANNING_URL;

export function getCustomerData(props: any) {
  return axios.post(`${API_URL}/account/customer`, {...props})
}

export function getServerStatusData(props: any) {
  return axios.post(`${API_URL}/account/server/status`, {...props})
}

export function getProjectInfoData(props: any) {
  return axios.post(`${API_URL}/account/projectInfo`, {...props})
}

export function getMobiSyncVersion(props: any) {
  return axios.post(`${API_URL}/account/projectinfo/mobisyncversion`, {...props})
}

export function getAppliedScriptData(props: any) {
  return axios.post(`${API_URL}/account/applied/scripts`, {...props})
}

export function getServiceType(props: any) {
  return axios.post(`${API_URL}/account/get_service_type`, {...props})
}

export function findCustomerData(props: any) {
  return axios.post(`${API_URL}/account/find/customer`, {...props})
}

export function applyScript(props: any) {
  return axios.post(`${API_URL}/account/apply/script`, {...props})
}

export function applyAllScript(props: any) {
  return axios.post(`${API_URL}/account/apply/all/scripts`, {...props})
}

export function checkDeviceIds(props: any) {
  return axios.post(`${API_URL}/system/function/checkdeviceids`, {...props})
}

export function saveCustomerData(props: any) {
  return axios.post(`${API_URL}/account/customer/save`, {...props})
}
export function saveProjectInfoData(props: any) {
  return axios.post(`${API_URL}/account/projectInfo/save`, {...props})
}

export function updateData(props: any) {
  return axios.post(`${API_URL}/portal/update`,  {...props})
}

export function updateSettingsData(props: any) {
  return axios.post(`${API_URL}/account/customer/settings/update`,  {...props})
}

export function updateServiceType(props: any) {
  return axios.post(`${API_URL}/account/update_service_type`, {...props})
}

export function insertData(props: any) {
  return axios.post(`${API_URL}/portal/insert`,  {...props})
}

export function deleteData(props: any) {
  return axios.post(`${API_URL}/portal/delete`,  {...props})
}

export function getQueryResults(props: any) { 
  return axios.post(`${API_URL}/portal/get_query_results`, {...props})
}

export function getFTPimages(props: any) {
  return axios.post(`${API_URL}/portal/get_ftp_images`, {...props})
}

export function getFiles(props: any) {
  return axios.post(`${API_URL}/public/get_files`, {...props})
}

export function deleteFiles(props: any) {
  return axios.post(`${API_URL}/public/delete`, {...props})
}

export function uploadFiles(props: any) {
  const { file, id, saltid, salt } = props;
  const formData = new FormData();
  file && formData.append("file", file);
  id && formData.append("id", id);
  saltid && formData.append("saltid", saltid);
  salt && formData.append("salt", salt);
  return axios.post(`${API_URL}/public/upload`, formData)
}

export function createMSConnection(props: any) {
  return axios.post(`${API_URL}/system/create/ms/connection`,  {...props})
}
export function refreshLicences(props: any) {
  return axios.post(`${API_URL}/maintain/reload/licences`,  {...props})
}

export function updateLicences(props: any) {
  return axios.post(`${API_URL}/maintain/update/licences`,  {...props})
}

export function createCloudSolo(props: any) {
  return axios.post(`${API_URL}/system/create/cloudsolo`,  {...props})
}

export function deleteCloudSolo(props: any) {
  return axios.post(`${API_URL}/system/delete/cloudsolo`,  {...props})
}

export function createPlanningTool(props: any) {
  return axios.post(`${PLANNING_API_URL}/system/create/planningtool`,  {...props})
}

export function deletePlanningTool(props: any) {
  return axios.post(`${PLANNING_API_URL}/system/delete/planningtool`,  {...props})
}

export function createOldPlanningTool(props: any) {
  return axios.post(`${API_URL}/system/create/oldplanningtool`,  {...props})
}

export function deleteOldPlanningTool(props: any) {
  return axios.post(`${API_URL}/system/delete/oldplanningtool`,  {...props})
}
